import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ThemeContext } from 'src/store/ContextStore';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function HeaderTitle(props) {
  const { theme } = React.useContext(ThemeContext);

  const { showBtn = false } = props;

  const t = useAutoTranslation();

  return (
    <Grid
      style={props.style ? props.style : {}}
      size={props.autoWidth ? 'auto' : 12}
    >
      <Typography
        variant={props.variant ?? 'h5'}
        component={props.component ?? 'h2'}
        sx={{
          color: theme.header,
          fontWeight: props.fontWeight ?? 500,
          ...(props.fontSize && { fontSize: props.fontSize })
        }}
        gutterBottom
      >
        {/* A string is our English, translated here; a node (a name, an
            identifier, or a sentence already translated with its values) is
            shown as it is, so its values are never sent to be translated. */}
        {typeof props.text === 'string' ? t(props.text) : props.text}
      </Typography>
      {/* <div className="margin-bottom-2" /> */}
      {showBtn && (
        <Button
          style={props.buttonStyle}
          disabled={props.disableAddBtn}
          variant="contained"
          color="secondary"
          onClick={props.addClicked}
          // className={classes.addButton}
          endIcon={<AddCircleIcon fontSize="small" />}
          size={props.addBtnSize ?? undefined}
        >
          {props.addText}
        </Button>
      )}
    </Grid>
  );
}
